import { useEffect } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";

interface Props {
  open: boolean;
  onDismiss: () => void;
}

const AUTO_DISMISS_MS = 4_000;

export const OrderSentToast = ({ open, onDismiss }: Props): JSX.Element => {
  const { t } = useTranslation();

  useEffect(() => {
    if (!open) return;
    const id = window.setTimeout(onDismiss, AUTO_DISMISS_MS);
    return () => clearTimeout(id);
  }, [open, onDismiss]);

  if (!open || typeof document === "undefined") return <></>;

  return createPortal(
    <div className="fixed bottom-32 inset-x-4 z-[80] max-w-md mx-auto pointer-events-none">
      <div
        className="bg-primary text-white rounded-card px-4 py-3 shadow-warm-lg animate-slide-up pointer-events-auto flex items-center gap-3"
        role="status"
        aria-live="polite"
      >
        <span aria-hidden="true" className="text-xl">
          🍳
        </span>
        <p className="flex-1 min-w-0 font-medium text-sm leading-snug">
          {t("notice.orderSent", "Commande envoyée 🍳")}
        </p>
        <button
          type="button"
          onClick={onDismiss}
          className="text-white/80 text-xs"
          aria-label={t("common.close", "Fermer")}
        >
          ✕
        </button>
      </div>
    </div>,
    document.body
  );
};
